import { Type } from '@angular/core';

import { PBArrayConfig } from './presentation-builder-config.model';

export const PBValueDataType = {
  TEXT: 'text',
  FIELD: 'field',
  FIELD_GROUP: 'fieldGroup',
} as const;

export interface PBValueDataBase {
  id: string;
}

export interface PBTextValueData extends PBValueDataBase {
  type: typeof PBValueDataType.TEXT;
  value: string;
}

export interface PBFieldValueData extends PBValueDataBase {
  type: typeof PBValueDataType.FIELD;
  component: Type<unknown>;
  inputs: Record<string, unknown>;
}

export type PBValueData = PBTextValueData | PBFieldValueData;

export type PBValueMapper<T> = (
  field: T,
  value: unknown
) => { label: string; value: unknown; rawValue: unknown };

export type PBValueMapper2<T> = (
  configItem: T,
  value: unknown
) => { component: Type<unknown>; inputs: Record<string, unknown> };

export type PBArrayValueMapper2<T> = (
  configItem: PBArrayConfig<T>,
  value: unknown
) => {
  id: string;
  type: typeof PBValueDataType.FIELD;
  component: Type<unknown>;
  inputs: Record<string, unknown>;
}[];
